/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerDocumentFetcherRequest
 */
export interface TriggerDocumentFetcherRequest {
    /**
     * 
     * @type {string}
     * @memberof TriggerDocumentFetcherRequest
     */
    requester_organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerDocumentFetcherRequest
     */
    requester_organization_name: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerDocumentFetcherRequest
     */
    requester_npi: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerDocumentFetcherRequest
     */
    hrr_zip_code: string;
}

/**
 * Check if a given object implements the TriggerDocumentFetcherRequest interface.
 */
export function instanceOfTriggerDocumentFetcherRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "requester_organization_id" in value;
    isInstance = isInstance && "requester_organization_name" in value;
    isInstance = isInstance && "requester_npi" in value;
    isInstance = isInstance && "hrr_zip_code" in value;

    return isInstance;
}

export function TriggerDocumentFetcherRequestFromJSON(json: any): TriggerDocumentFetcherRequest {
    return TriggerDocumentFetcherRequestFromJSONTyped(json, false);
}

export function TriggerDocumentFetcherRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerDocumentFetcherRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requester_organization_id': json['requester_organization_id'],
        'requester_organization_name': json['requester_organization_name'],
        'requester_npi': json['requester_npi'],
        'hrr_zip_code': json['hrr_zip_code'],
    };
}

export function TriggerDocumentFetcherRequestToJSON(value?: TriggerDocumentFetcherRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requester_organization_id': value.requester_organization_id,
        'requester_organization_name': value.requester_organization_name,
        'requester_npi': value.requester_npi,
        'hrr_zip_code': value.hrr_zip_code,
    };
}

